import React, { useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { http } from "../helper";
import DataTable from "react-data-table-component";
import { BaseUrl } from "../common/config";
import Sidebar from "../common/sidebar";
import { canAction } from "../common/permissionhelper";
import { useTranslation } from "react-i18next";

const MasterAccountcode = () => {
  const { t } = useTranslation();
  const [searchTextVal, setSearchTextVal] = useState("");
  const [accountcodelist, setAccountcodelist] = useState([]);
  const [templist, setTemplist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [accountcodevalue, setAccountcodevalue] = useState("");

  useEffect(() => {
    if (!sessionStorage.getItem("isLoggedIn")) {
      window.location.href = "/";
      return;
    }
    const authData = JSON.parse(sessionStorage.getItem("authData"));
    if (
      authData !== "" &&
      !authData.adminRole.permissions.includes("manage_masterentry")
    ) {
      window.location.href = "/unauthorized";
      return;
    }
    getAccountcodelist();
  }, []);

  const getAccountcodelist = () => {
    const URL = BaseUrl + "admin/masteraccountcodelist";
    http
      .get(URL)
      .then((response) => {
        setAccountcodelist(response.data.data);
        setTemplist(response.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChange = (value) => {
    setSearchTextVal(value);
    filterData(value);
  };

  const filterData = (value) => {
    const lowercasedValue = value.toLowerCase().trim();
    if (lowercasedValue.length > 0) {
      const result = templist.filter((item) =>
        (item.accountCode ?? "")
          .toString()
          .toLowerCase()
          .includes(lowercasedValue),
      );
      setAccountcodelist(result);
    } else {
      setAccountcodelist(templist);
    }
  };

  const handleReset = () => {
    setSearchTextVal("");
    setAccountcodelist(templist);
  };

  const addaccountcode = () => {
    window.location.href = "/masteraccountcode/accountcode/add/";
  };

  const editaccountcode = (value) => {
    window.location.href = `/masteraccountcode/accountcode/edit/${value._id}/`;
  };

  const deleteAccountcode = (value) => {
    setVisibleAlert(true);
    setAccountcodevalue(value);
  };

  const deleteAccountcodeValue = () => {
    const URL = BaseUrl + `admin/masteraccountcode/${accountcodevalue._id}`;
    http
      .delete(URL)
      .then((response) => {
        if (response.data.success === true) {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const alertPopupclose = () => {
    setVisibleAlert(false);
    setAccountcodevalue("");
  };

  const columns = [
    {
      name: t("account_code_txt"),
      selector: (row) => row.accountCode,
      sortable: true,
    },
    {
      name: t("actions_txt"),
      selector: (row) => {
        const canEdit = canAction("manage_masterentry", "edit");
        return (
          <div style={{ display: "flex" }}>
            <a
              className="button title-tooltip title-up"
              data-title={canEdit ? t("edit_txt") : t("view_txt")}
              style={{ color: "white" }}
              onClick={() => editaccountcode(row)}
            >
              <i
                className={`fa ${canEdit ? "fa-pencil" : "fa-eye"}`}
                aria-hidden="true"
              ></i>
            </a>
            {canAction("manage_masterentry", "delete") && (
              <a
                className="button title-tooltip title-up"
                data-title={t("delete_txt")}
                style={{ color: "white" }}
                onClick={() => deleteAccountcode(row)}
              >
                <i className="fa fa-trash" aria-hidden="true"></i>
              </a>
            )}
          </div>
        );
      },
      sortable: false,
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "25px",
      },
    },
    headCells: {
      style: {
        padding: "8px",
      },
    },
    cells: {
      style: {
        padding: "8px",
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "",
    rangeSeparatorText: "",
    selectAllRowsItem: true,
    selectAllRowsItemText: "",
    noRowsPerPage: "",
  };

  return (
    <>
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <h1 className="checkout-title">{t("master_login_accounts_txt")}</h1>
              <div className="right-table-outer-wrap">
                <div className="table-filter search-orders">
                  <div className="table-search-reset">
                    <div className="table-search">
                      <input
                        type="text"
                        value={searchTextVal}
                        onChange={(e) => handleChange(e.target.value)}
                        className="form-control"
                        placeholder={t("search_by_code_txt")}
                      />
                    </div>
                    <button
                      className="submitbtn button search-holi-btn"
                      onClick={() => filterData(searchTextVal)}
                    >
                      <i className="fa fa-search"></i>
                    </button>
                    <button
                      className="resetbtn"
                      type="reset"
                      onClick={handleReset}
                    >
                      {t("reset_txt")}
                    </button>
                  </div>
                  {canAction("manage_masterentry", "add") && (
                    <div className="add-holidaybtn">
                      <button className="addbtn" onClick={addaccountcode}>
                        {t("add_txt")}
                      </button>
                    </div>
                  )}
                </div>
                <div className="table_overflow">
                  <DataTable
                    columns={columns}
                    noDataComponent={
                      <div className="no-records-found">
                        {t("no_account_code_found_txt")}
                      </div>
                    }
                    data={accountcodelist}
                    customStyles={customStyles}
                    pagination
                    paginationPerPage={25}
                    progressPending={loading}
                    paginationRowsPerPageOptions={[25, 50, 75, 100]}
                    paginationComponentOptions={paginationComponentOptions}
                  />
                </div>
              </div>
            </div>
          </section>
          <Footer />
        </div>
      </div>
      {visibleAlert && (
        <div className="custom-alert-pop paylater-popup">
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{t("confirm_delete_txt")}</p>
                <div className="alert-buttons">
                  <a
                    title={t("ok_txt")}
                    onClick={deleteAccountcodeValue}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                  <a
                    title={t("cancel_txt")}
                    onClick={alertPopupclose}
                    className="popup-alert-btn button"
                  >
                    {t("cancel_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MasterAccountcode;
